import React, { useEffect } from 'react';
import './DailyLogDashboardModal.css';

const CustomerRow = ({ customer, hasLog, onView, t }) => {
  const needsAttention = hasLog && Number(customer.percentage) < 65;
  return (
    <div className={`daily-monitor-customer${needsAttention ? ' needs-attention' : ''}`}>
      <div>
        <strong>{customer.customerName}</strong>
        <span>{t(customer.customerType)}</span>
      </div>
      {hasLog ? (
        <>
          <div className="daily-monitor-score">
            <strong>{customer.percentage}%</strong>
            <span>{customer.score}/11</span>
          </div>
          <button type="button" className="btn btn-secondary" onClick={() => onView(customer)}>{t('View Daily Log')}</button>
        </>
      ) : <span className="daily-monitor-missing">{t('Not submitted')}</span>}
    </div>
  );
};

const DailyLogDashboardModal = ({ data, loading, error, onClose, onView, t }) => {
  const monitoredDate = data?.logDate
    ? new Date(`${data.logDate}T00:00:00`).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
    : '';
  useEffect(() => {
    const closeOnEscape = event => event.key === 'Escape' && onClose();
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [onClose]);

  return (
    <div className="daily-monitor-overlay" onMouseDown={event => event.target === event.currentTarget && onClose()}>
      <div className="daily-monitor-modal" role="dialog" aria-modal="true" aria-labelledby="daily-monitor-title">
        <header>
          <div>
            <h2 id="daily-monitor-title">{t('Daily Log Monitoring')}</h2>
            <p>{t("Checking yesterday's log dated {date}", { date: monitoredDate })}</p>
          </div>
          <button type="button" className="daily-monitor-close" onClick={onClose} aria-label={t('Close')}>×</button>
        </header>

        {loading ? <div className="daily-monitor-message">{t('Loading daily log status...')}</div> :
          error ? <div className="daily-monitor-message error">{error}</div> : data && <>
            <div className="daily-monitor-summary">
              <div><span>{t('Active Customers')}</span><strong>{data.totalActiveCustomers}</strong></div>
              <div className="submitted"><span>{t('Submitted')}</span><strong>{data.filledCount}</strong></div>
              <div className="missing"><span>{t('Not Submitted')}</span><strong>{data.notFilledCount}</strong></div>
            </div>

            <section className="daily-monitor-section">
              <div className="daily-monitor-section-title">
                <h3>{t('Daily log submitted')}</h3><span>{data.filledCount}</span>
              </div>
              <p className="daily-monitor-hint">{t('Customers below 65% are highlighted for attention.')}</p>
              <div className="daily-monitor-list">
                {data.filled.length ? data.filled.map(customer => <CustomerRow key={customer.customerId} customer={customer} hasLog onView={onView} t={t} />) :
                  <div className="daily-monitor-empty">{t("No customers have submitted yesterday's daily log.")}</div>}
              </div>
            </section>

            <section className="daily-monitor-section">
              <div className="daily-monitor-section-title">
                <h3>{t('Daily log not submitted')}</h3><span>{data.notFilledCount}</span>
              </div>
              <div className="daily-monitor-list">
                {data.notFilled.length ? data.notFilled.map(customer => <CustomerRow key={customer.customerId} customer={customer} hasLog={false} onView={onView} t={t} />) :
                  <div className="daily-monitor-empty">{t("Every active customer has submitted yesterday's daily log.")}</div>}
              </div>
            </section>
          </>}
      </div>
    </div>
  );
};

export default DailyLogDashboardModal;
